import React from 'react'

import { CenterArea, Nav, NavContent } from './styles'
import { AreaLineProps } from './type'

const AreaLine = ({
  colorScheme,
  leftAreaElement,
  centerAreaElement,
  rightAreaElement,
  alignment = 'left',
  placement = 'default',
  heightClass = 'regular',
  className,
  minorGutter = false,
  ...htmlProps
}: AreaLineProps) => {
  const renderArea = (element: React.ReactElement) => {
    const isDOMElement = typeof element.type === 'string'

    const props = isDOMElement
      ? { ...element.props }
      : { ...element.props, heightClass }

    return React.cloneElement(element, props)
  }

  return (
    <Nav
      {...htmlProps}
      colorScheme={colorScheme}
      heightClass={heightClass}
      className={className}
      minorGutter={minorGutter}
      placement={placement}
      role='navigation'
    >
      <NavContent
        colorScheme={colorScheme}
        heightClass={heightClass}
        minorGutter={minorGutter}
      >
        {leftAreaElement && <div>{renderArea(leftAreaElement)}</div>}
        <CenterArea alignment={alignment}>
          {centerAreaElement && renderArea(centerAreaElement)}
        </CenterArea>
        {rightAreaElement && <div>{renderArea(rightAreaElement)}</div>}
      </NavContent>
    </Nav>
  )
}

export default AreaLine
